import React from 'react';
import { useField } from 'formik';

import ErrorMessage from '_utils/components/Form/ErrorMessage';

import { TextInputProps } from './definitions';
import { TextBoxInput } from './StyledTextInput'

const TextInput: React.FC<TextInputProps> = (props) => {
  const [field, meta] = useField(props);
  const { errAnalyticsId, errAnalyticsGroup} = props
  const hasError = !!((meta?.touched || meta?.initialTouched) && meta?.error);

  return (
    <>
      <TextBoxInput
        hasError={hasError}
        {...field}
        {...props}
      />

      {hasError && <ErrorMessage analyticsId={errAnalyticsId} analyticsGroup={errAnalyticsGroup}>{meta.error}</ErrorMessage>}
    </>
  );
};


export default TextInput;